import { Navigate, useLocation } from 'react-router-dom';

export default function CheckoutNew() {
  const { search } = useLocation();
  return <Navigate to={`/checkout${search}`} replace />;
}
